import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { StakeholderReferenceFacade } from '../../states/+stakeholderreference/stakeholderreference.facade';
import { StakeholderReferenceDto, CountryDto } from '@cradua/data';
import { CountryFacade } from './../../../../../epims-references/src/lib/states/+country/country.facade';

@Component({
  selector: 'mrsoftapps-GenericReference-container',
  templateUrl: './GenericReference.component.html',
  styleUrls: ['./GenericReference.component.css'],
})
export class GenericReferenceContainerComponent implements OnInit {
  isLoadingStakeholderReference$: Observable<any>;
  stakeholderrefData$: Observable<any[]>;
  countries$: Observable<CountryDto[]>;
  stakeholdergroups$: Observable<StakeholderReferenceDto[]>;
  isLoadingStakeholderReferenceGroup$: Observable<any>;

  stakeholderreferences: any[];

  stakeholderreference$: Observable<StakeholderReferenceDto[]>;
  selectedReferenceType: string = 'Language';
  selectedCountryId: string;
  selectedStakeholderGroupId: string;

  data;
  task = 'load';

  constructor(
    private stakeholderreferenceFacade: StakeholderReferenceFacade,
    private countryFacade: CountryFacade
  ) {}

  ngOnInit() {
    this.stakeholdergroups$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReferenceGroup(
      'StakeholderGroup',
      this.selectedCountryId,
      this.selectedStakeholderGroupId
    );
    this.isLoadingStakeholderReference$ = this.stakeholderreferenceFacade.isLoadingByTypeStakeholderReference(
      'Language',
      this.selectedCountryId,
      this.selectedStakeholderGroupId
    );
    this.stakeholderrefData$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReference(
      'Language',
      this.selectedCountryId,
      this.selectedStakeholderGroupId
    );

    this.stakeholderrefData$.subscribe((data) => {
      this.stakeholderreferences = data.map((item) => {
        return {
          Name: item.Name,
          Desc: item.Desc,
          Address: item.Address,
          Location: item.Location,
          CountryId: item.CountryId,
          SubscriberId: item.SubscriberId,
          SiteId: item.SiteId,
          SectorId: item.SectorId,
          StakeholderGroupId: item.StakeholderGroupId,
          id: item.id,
        };
      });
    });
  }

  selectedValueChange(type: string) {
    this.selectedReferenceType = type;

    console.log(
      'Selected Value on Ref Type Select ',
      this.selectedReferenceType
    );
    if (this.selectedReferenceType === 'StakeholderSubGroup') {
      console.log('Loading Group');
      this.stakeholdergroups$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReferenceGroup(
        'StakeholderGroup',
        this.selectedCountryId,
        this.selectedStakeholderGroupId
      );
      //this.isLoadingStakeholderReferenceGroup$ = this.stakeholderreferenceFacade.isLoadingByTypeStakeholderReferenceGroup("Language",this.selectedCountryId, this.selectedStakeholderGroupId);
      this.stakeholderrefData$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReference(
        type,
        this.selectedCountryId,
        this.selectedStakeholderGroupId
      );
    } else if (this.selectedReferenceType === 'Organization') {
      console.log('Loading Organization ', type);
      this.stakeholdergroups$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReferenceGroup(
        'Sector',
        this.selectedCountryId,
        this.selectedStakeholderGroupId
      );
      //this.isLoadingStakeholderReferenceGroup$ = this.stakeholderreferenceFacade.isLoadingByTypeStakeholderReferenceGroup("Language",this.selectedCountryId, this.selectedStakeholderGroupId);
      this.stakeholderrefData$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReference(
        type,
        this.selectedCountryId,
        this.selectedStakeholderGroupId
      );
    } else if (
      this.selectedReferenceType === 'Club' ||
      this.selectedReferenceType === 'League'
    ) {
      this.countries$ = this.countryFacade.loadCountry;
      this.stakeholderrefData$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReference(
        type,
        this.selectedCountryId,
        this.selectedStakeholderGroupId
      );
    } else {
      console.log('Reaching Second Block');
      //this.isLoadingStakeholderReference$ = this.stakeholderreferenceFacade.isLoadingByTypeStakeholderReference(type,this.selectedCountryId, this.selectedStakeholderGroupId);
      this.stakeholderrefData$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReference(
        type,
        this.selectedCountryId,
        this.selectedStakeholderGroupId
      );
    }
  }

  selectedCountryChange(countryId: string) {
    this.selectedCountryId = countryId;

    console.log('Selected Country ', this.selectedCountryId);
    this.isLoadingStakeholderReference$ = this.stakeholderreferenceFacade.isLoadingByTypeStakeholderReference(
      this.selectedReferenceType,
      this.selectedCountryId,
      this.selectedStakeholderGroupId
    );
    this.stakeholderrefData$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReference(
      this.selectedReferenceType,
      this.selectedCountryId,
      this.selectedStakeholderGroupId
    );
  }

  selectedStakeholderGroupChange(stakeholdergroupId: string) {
    this.selectedStakeholderGroupId = stakeholdergroupId;
    console.log('Selected Stakeholder Group ', this.selectedStakeholderGroupId);
    //this.isLoadingStakeholderReference$ = this.stakeholderreferenceFacade.isLoadingByTypeStakeholderReference(this.selectedReferenceType,this.selectedCountryId, this.selectedStakeholderGroupId);
    this.stakeholderrefData$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReference(
      this.selectedReferenceType,
      this.selectedCountryId,
      this.selectedStakeholderGroupId
    );
    //this.stakeholdergroups$ = this.stakeholderreferenceFacade.loadByTypeStakeholderReferenceGroup("StakeholderGroup",this.selectedCountryId, this.selectedStakeholderGroupId);
  }

  onDelete(deletedValue: any[]) {
    console.log('OnDelete event called', deletedValue);
    //deletedValue.shift();

    this.stakeholderreferenceFacade.removeStakeholderReference(
      deletedValue,
      this.selectedReferenceType
    );
  }

  // this method control both the create and update

  onSubmitStakeholderReference(formValue: any) {
    event.preventDefault();
    const pullData = formValue.StakeholderReferences;

    // declare two empty array to hold update and create data
    let allUpdates = [];
    let addAllStakeholderReferences = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        addAllStakeholderReferences.push(pullData[i]);
      }
    }

    // check if the addAllCountry array is not empty, then dispatch the data to the store
    if (addAllStakeholderReferences.length !== 0) {
      this.stakeholderreferenceFacade.addStakeholderReference(
        addAllStakeholderReferences,
        this.selectedReferenceType
      );
    }

    // check if there is any update on the object
    const getChange = this.getChanges(this.stakeholderreferences, allUpdates);
    //console.log("Change Data ", allUpdates, this.stakeholderreferences);
    if (getChange) {
      // dispatch update data to the store
      this.stakeholderreferenceFacade.updateStakeholderReference(
        allUpdates,
        this.selectedReferenceType
      );
    }
  }

  getChanges(oldArray, newArray) {
    let changes, i, item, j, len;
    if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
      return false;
    }
    changes = [];
    for (i = j = 0, len = newArray.length; j < len; i = ++j) {
      item = newArray[i];
      if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
        changes.push(item);
      }
    }
    return changes;
  }
}
